import React from 'react';

export const AuthContentWrapper: React.FC = ({ children }) => {
  return (
    <div className="leo-auth-content-wrapper" style={{}}>
      {children}
    </div>
  );
};
